import { ApiGroup } from '../types/ApiTypes';

export const PointPolicyAPI: ApiGroup = {
    pagedList: {
        title: '포인트 정책 목록 조회',
        method: 'POST',
        url: '/PointPolicy/PagedList',
        paramz: {},
    },
    list: {
        title: '포인트 정책 전체 목록 조회',
        method: 'GET',
        url: '/PointPolicy/List',
        paramz: {},
    },
    create: {
        title: '포인트 정책 생성',
        method: 'POST',
        url: '/PointPolicy/Create',
        paramz: {},
    },
    update: {
        title: '포인트 정책 수정',
        method: 'PUT',
        url: '/PointPolicy/Update',
        paramz: {},
    },
    delete: {
        title: '포인트 정책 삭제',
        method: 'DELETE',
        url: '/PointPolicy/Delete',
        paramz: {},
    },
};
